module.exports = __webpack_public_path__ + "static/Stars-45f7e97bbbd70d20ef3881f2d4f71ca2.svg";